import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import "antd/dist/antd.css";
import "../../css/users.css";
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import LeftSideNav from "../../components/LeftSideNav";
import { isEmailValid } from "../../functions/commons";
import { isEmpty, isNil } from "lodash";
import {
  useLazyProfileCompleteCheckQuery,
  useLoginUserMutation,
} from "../../store/appSlice";
import { useAppDispatch } from "../../store/store";
import { reset, setAuth, setProfileComplete } from "../../reducers/userReducer";

function LoginUser() {
  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
    },
  };

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [input, setInput] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState({
    email: "",
    password: "",
  });

  const [loginUser] = useLoginUserMutation();

  const [trigger, { data: profileStatus }] = useLazyProfileCompleteCheckQuery();

  const [errorMessage, setErrorMessage] = useState<string>("");

  const [isLoading, setLoading] = useState<boolean>(false);

  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const [verified, setVerified] = useState<boolean>(false);

  useEffect(() => {
    if (!isEmpty(errorMessage)) {
      setTimeout(() => {
        setErrorMessage("");
      }, 2000);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (!isNil(profileStatus)) {
      reset();

      if (!profileStatus?.isSignUpProcessCompleted) {
        navigate("/profile/basic");
      } else {
        dispatch(setProfileComplete(true));
        navigate("/");
      }
    }
  }, [profileStatus]);

  const validation = () => {
    const { email, password } = input;

    let valid = true;
    let emailError = "";
    let passwordError = "";
    if (isEmpty(password)) {
      valid = false;
      passwordError = "Password cannot be empty";
    }
    if (!isEmailValid(email)) {
      console.log("inside");
      valid = false;
      emailError = "Email is invalid";
    }
    if (isEmpty(email)) {
      valid = false;
      emailError = "Email cannot be empty";
    }

    setError({
      ...error,
      email: emailError,
      password: passwordError,
    });

    return valid;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput({
      ...input,
      [event.target.id]: event.target.value,
    });
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    if (validation()) {
      // if (true) {
      setLoading(true);
      const payload = {
        email: input.email,
        password: input.password,
      };

      loginUser(payload)
        .unwrap()
        .then((incomingData: any) => {
          console.log({ incomingData });
          setLoading(false);

          if (!isNil(incomingData?.id)) {
            dispatch(setAuth(incomingData));
            console.log({ incomingData });
            trigger(incomingData?.id)
              .unwrap()
              .then((profileCheckIncomingData: any) => {});
          }
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage("Invalid credentials");
        });
    }
  };

  const inputFormView = () => (
    <div className="main-right-div">
      <div className="right-header-div">
        <h4>Don't have an account?</h4>

        <Button
          onClick={() => {
            reset();
            navigate("/auth/signup");
          }}
        >
          Get Started
        </Button>
      </div>
      <div className="signin-form-div">
        <h2>Sign in</h2>
        <p>Enter your details to hire great talent</p>
        {/* {console.log("error", showError)} */}
        {!isEmpty(errorMessage) && (
          <Alert closable message={errorMessage} type="error" />
        )}
        <Form {...layout} onFinish={handleSubmit}>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Email</h2>
          </div>
          <Form.Item name="email">
            <Input
              type="text"
              value={email}
              id="email"
              onChange={handleOnChange}
              style={!isEmpty(error.email) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.email) && (
              <text style={{ color: "red" }}>{error.email}</text>
            )}
          </Form.Item>
          <div
            className="sign-in__pswrd-frgt-pswrd"
            style={{
              justifyContent: "space-between",
              width: "450px",
            }}
          >
            <h2>Password</h2>
            <Link to="/auth/forgot_password">
              <h3 className="forgot-password">Forgot your password?</h3>
            </Link>
          </div>

          <Form.Item name="password">
            {/* <Input
              type="password"
              value={password}
              id="password"
              onChange={handleOnChange}
              style={!isEmpty(error.password) ? { borderColor: "red" } : {}}
            />
    */}
            <Input.Password
              type="password"
              value={password}
              id="password"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.password) ? { borderColor: "red" } : {}}
            />
            {!isEmpty(error.password) && (
              <text style={{ color: "red" }}>{error.password}</text>
            )}
          </Form.Item>

          {/* <ReCAPTCHA
            ref={recaptchaRef}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
            }}
            // sitekey="6Lf9bR8nAAAAABlnMXqFv1Y_rqPPLUTRpASCWXh_" //staging
            sitekey="6Ld4DhAnAAAAAL8GnDgf2efNiuV6KGkSCfl067v_" //prod
            onChange={() => setVerified(true)}
          /> */}

          <Form.Item>
            <div style={{ marginTop: 20, opacity: verified ? 1 : 0.5 }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                // disabled={isLoading || !verified}
              >
                Sign in
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );

  const { email, password } = input;
  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="inputform_container">{inputFormView()}</div>
    </div>
  );
}

export default LoginUser;
